import React from "react";
import fbicon from '../../Assets/Images/outline-facebookicon.png'
import twitter from '../../Assets/Images/twitter-fill.png'
import pinterest from '../../Assets/Images/pinterest-fill.png'
import youtube from '../../Assets/Images/youtubeIcon.png'
const MeetOurExpectTeam = () => {
  return (
    <div className="container">
      <div className="row about-expert-team">
        <div className="col-lg-4 about-expert-team-content">
          <h1>
            Meet Our <br />
            Expert Team
          </h1>
          <p>
            Our team of certified ISO professionals, auditors, and trainers
            bring years of industry experience to every project. With a shared
            passion for quality and compliance, we work closely with you to
            ensure a smooth certification journey and lasting business success.
          </p>

          <button>Get Started</button>
        </div>
        <div className="col-lg-4 about-expert-team-banner-one">
            <div className="christ-mattew-content-img">
                <h4 style={{color:'white'}}>Christ Mattew</h4>
                <p style={{color:'white'}}>Chief Technology Officer</p>
                <div className="d-flex gap-2">
                   <img className="expert-team-banner-icon" src={fbicon} alt="" />
                   <img className="expert-team-banner-icon" src={twitter} alt="" />
                   <img className="expert-team-banner-icon" src={pinterest} alt="" />
                   <img className="expert-team-banner-icon" src={youtube} alt="" />
                </div>
            </div>
        </div>
        <div className="col-lg-4 about-expert-team-banner-two">
            <div className="benjamin-content-img">
                <h4 style={{color:'white'}}>Benjamin Foster</h4>
                <p style={{color:'white'}}>Ceo Portal</p>
                <div className="d-flex gap-2">
                   <img className="expert-team-banner-icon" src={fbicon} alt="" />
                   <img className="expert-team-banner-icon" src={twitter} alt="" />
                   <img className="expert-team-banner-icon" src={pinterest} alt="" />
                   <img className="expert-team-banner-icon" src={youtube} alt="" />
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default MeetOurExpectTeam;
